export default "__VITE_PUBLIC_ASSET__cfca10d9__"